import { createLocalCartUuidStore } from '@iheartjane/menu';
import type { AppMode } from '@iheartjane/types';
import { Storage } from '@iheartjane/utils';

import { cartStorageKey } from '@jane/monolith/customer/redux/cart';

/**
 * Adoption read: pre-flip bags exist only as Redux's persisted cart, so without
 * this `c3UseV3Cart` empties every one. Cart-less it holds `uuid: ''` → absent.
 *
 * TODO(carts-v3): delete legacy utils with the Redux slice at slot 017, and `storeId` with it.
 */
const legacyStoredCartUuid = (appMode: AppMode, storeId?: string | number) =>
  Storage.get<{ uuid?: string }>(cartStorageKey(appMode, storeId))?.uuid ||
  null;

const clearLegacyStoredCart = (appMode: AppMode, storeId?: string | number) =>
  Storage.remove(cartStorageKey(appMode, storeId));

const { getLocalCartUuid, updateLocalCartUuid, useLocalCartUuid } =
  createLocalCartUuidStore({
    legacyClear: clearLegacyStoredCart,
    legacyRead: legacyStoredCartUuid,
    // The three embed modes are partner-scoped, matching the `-tags` /
    // `-promo-code` suffixes already hung off this base key.
    storageKey: (appMode, storeId) =>
      `${cartStorageKey(appMode, storeId)}-uuid`,
  });

export { getLocalCartUuid, updateLocalCartUuid, useLocalCartUuid };
